<div class="ai-chat-dialog">
    <button class="ai-chat-dialog__close-btn" (click)="closeDialog()">
        <span></span>
        <span></span>
    </button>
    <h3 class="ai-chat-dialog__title">{{ "AI_DIALOG.TITLE" | translate }}</h3>
    <div class="ai-chat-dialog__content">
        <div class="ai-actions">
            <p [innerHTML]="'AI_DIALOG.SUBTITLE' | translate"></p>
            <div class="ai-actions__buttons">
                <button class="action-box"
                        [disabled]="isDisabledCustomizeTripBtn"
                        (click)="printElementRef.tripPlanPrint()"
                >
                    <img src="assets/svg/ic-print-w.svg" alt="print">
                    <p>{{ 'BUTTONS.PRINT' | translate }}</p>
                </button>
            </div>
        </div>
        <div class="map-text">
            <p>{{ 'AI_DIALOG.YOUR_ROUTE' | translate }}</p>
        </div>
        <div class="chat-box">
            <div class="chat-box__container">
                @if (!messages.length) {
                    <div class="chat-box__welcome">
                        <div class="chat-box__welcome__title">
                            @if (userProfile) {
                                <span class="avatar-text">
                                {{ userProfile.name[0] }}
                            </span>
                            } @else {
                                <img class="avatar-img" alt="Routeperfect AI" src="assets/svg/ic-chat-user.svg">
                            }
                            <div class="welcome-texts">
                                <h4>{{ 'AI_DIALOG.HELLO_TEXT' | translate }}</h4>
                                <p>{{ 'AI_DIALOG.START_WITH_EXAMPLE' | translate }}</p>
                            </div>
                        </div>
                        <ul class="chat-box__welcome__proposes">
                            @for (exampleText of examples; let idx = $index; track idx) {
                                <li class="propose-item" (click)="selectExampleText(exampleText, textAreaRef)">
                                    {{ exampleText }}
                                </li>
                            }
                        </ul>
                    </div>
                } @else {
                    <div class="chat-box__messages">
                        <div class="messages-list" #messagesList>
                            @for (message of messages; let idx = $index; track idx) {
                                <div class="messages-list__item" [@questionInAnimation]>
                                    @if (userProfile) {
                                        <span class="avatar-text chat">
                                          {{ userProfile.name[0] }}
                                        </span>
                                    } @else {
                                        <img class="avatar-img chat" alt="Routeperfect AI" src="assets/svg/ic-chat-user.svg">
                                    }
                                    <p class="text">{{ message.question }}</p>
                                </div>

                                <div [id]="'element-id-' + idx" [@answerInAnimation] class="messages-list__item">
                                    <img class="avatar-img avatar-img--absolute avatar-img--ai" alt="Routeperfect AI"
                                         src="assets/svg/ic-logo.svg">
                                    <p class="text"
                                       [class.typewriter]="message.typewriting"
                                       [innerHTML]="message.answer"
                                    ></p>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="map-box">
            <app-preview-map
                    [countryCoordinates]="countryCoordinates"
                    [destinationsRoute]="destinationsRoute"
            ></app-preview-map>
            <div class="custom-trip" [class.show]="isCustomizeThisTripConfirmation">
                <h3>{{ 'AI_DIALOG.CUSTOMIZE_TRIP' | translate }}</h3>
                <p>{{ 'AI_DIALOG.GREAT_THIS_TRIP_NOT_EDITING' | translate }}</p>
                <p>{{ 'AI_DIALOG.IN_CASE_WORKING_ANOTHER_TRIP' | translate }}</p>
                <p>{{ 'AI_DIALOG.DONT_FORGET_TURN_ROUTE' | translate }}</p>
                <div class="custom-trip__actions">
                    <button class="btn-default btn-primary custom-trip__actions--cancel"
                            (click)="isCustomizeThisTripConfirmation = false">
                        {{ 'ACTIONS.CANCEL' | translate }}
                    </button>
                    <button class="btn-default btn-primary custom-trip__actions--ok" (click)="submitCustomizeAiTrip()">
                        {{ 'ACTIONS.OK' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="input-box">
            <div class="input-box__content">
                <textarea
                    #textAreaRef
                    class="input"
                    type="text"
                    [placeholder]="'AI_DIALOG.START_CONVERSATION' | translate"
                    [maxlength]="MAX_STRING_LENGTH"
                    (input)="autoGrow(textAreaRef)"
                    (keydown.enter)="sendMessage()"
                    [formControl]="inputText"
                ></textarea>
                <button class="btn-default btn-send"
                        [disabled]="inputText.value.length < 14"
                        (click)="sendMessage()"
                ></button>
                @if (inputText.value.length >= MAX_STRING_LENGTH - 10) {
                    <span class="max-length">
                        <b>{{ inputText.value.length }}</b> / {{ MAX_STRING_LENGTH }}
                    </span>
                }
            </div>
            <div class="ai-chat-dialog__footer">
                <p class="bot-mistake">
                    {{ 'AI_DIALOG.BOT_CAN_MISTAKES' | translate }}
                </p>
                <button class="btn-default btn-primary start-chat"
                        (click)="resetChat()"
                        [disabled]="isDisabledCustomizeTripBtn">
                    {{ 'ACTIONS.CLEAR_ANF_START_NEW_CHAT' | translate }}
                </button>
            </div>
        </div>
        <div class="trip-options">
            <button class="btn-default btn-primary--outline discard-chat-btn" (click)="closeDialog()">
                {{ 'BUTTONS.DISCARD_N_CLOSE' | translate }}
            </button>
            <button class="btn-default btn-primary customize-trip-btn"
                    [disabled]="isDisabledCustomizeTripBtn"
                    (click)="isCustomizeThisTripConfirmation = true">
                {{ 'BUTTONS.CUSTOMIZE_TRIP' | translate }}
            </button>
        </div>
    </div>
</div>

<app-trip-plan-print
    #printElementRef
    [tripId]="'ai-chat'"
    [tripName]="'Ai Trip plan'"
    [itineraryItems]="destinations"
></app-trip-plan-print>
